import React from "react";
import debounce from 'debounce';

import { Col, Input, InputNumber, message, Row } from 'antd';

import { 
	_postAddCustomProduct,
	_postSearchCustomProducts,
	_postUpdateCustomProductPrice
} from '../../../services';

class CustomProductSelector extends React.Component{

	render(){

		return (
			<Row type="flex" gutter={16}>
				
				<Col style={{ position:"relative" }}>
					<Input 
						onClick={ this.hanleOnClickInput }
						value={ this.state.title }
						onChange={ this.handleOnChangeCustomProductTitle }
						onFocus={ this.handleOnFocusSelectAllText }/>


					{ this.renderAutoComplete() }
				</Col>

				<Col>
					<InputNumber
						formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
						style={{ width: 80 }} 
						value={ this.state.productPrice }
						onChange={ this.handleOnChangeCustomProductPrice }/>

				</Col>
				
			</Row>
		)

	}

	renderAutoComplete = () => {
		
		const { results, title, touched, typed } = this.state;

		if( (title.length < 4 && results.length === 0) || touched === false || typed === false){

			return null;
			
		}

		return (
			<div 
				style={{ 
					position: "absolute", 
					top: 30, 
					background: "white", 
					zIndex: 999,
					border: "1px solid #d9d9d9",
					borderRadius: 4
				}}> 

				{results.map(
					customProduct => (
						<div 
							onClick={ () => this.handleOnSelectCustomProductTitle( customProduct ) }
							style={{
								padding: "4px 8px",
								borderBottom: "1px solid #d9d9d9",
								cursor: "pointer",
							}}>
							<a>{customProduct.title}</a>
						</div>
					)
				)}

				<div 
					style={{
						padding: "4px 8px",
						cursor: "pointer"
					}}
					onClick={ this.handleOnClickAddCustomProduct }>Add "{this.state.title}"</div>


			</div>
		)
	}

	constructor( props ){
		super(props);

		this.doSearchForReasons = debounce( this.doSearchForReasons, 300 );
		this._dbnceUpdateCustomProductPrice = debounce( this._dbnceUpdateCustomProductPrice, 500 );

		this.state = {
			title: props.title,
			productPrice: props.price,
			
			/**
			 * to refactor again
			 */
			holdingListId: props.holdingListId,
			productIndex: props.productIndex,
			/**
			 * to refactor again
			 */

			_id: props._id,
			results: [],
			touched: false,
			typed: false
		}

	}

	componentWillReceiveProps(nextProps) {
		this.setState({ title: nextProps.title });  
	}

	_dbnceUpdateCustomProductPrice = () => {

		const { 
			productPrice,
			holdingListId,
			productIndex
		} = this.state;

		_postUpdateCustomProductPrice({
			holdingListId,
			productPrice,
			productIndex
		})
			.then( res => {
				
				this.props.updateProduct({
					productIndex, 
					product: res.data.product
				});
				
				message.success(`Updated price to ${productPrice} successfully.`);

			})
			.catch( e => {
				message.error("Unexpected error. Please report.");
			})


	}

	doSearchForReasons = () => {
		
		const { title } = this.state;

		_postSearchCustomProducts( title )
			.then( res => {
				
				this.setState({
					results: res.data.data
				});

			})
			.catch( e => {
				message.error("Unexpected error. Please report.");
			})


	}

	hanleOnClickInput = () => {
		this.setState({ touched: true });
	}

	handleOnChangeCustomProductTitle = ( e ) => {
		
		this.setState({
			typed: true,
			title: e.target.value
		});

		message.destroy();

		this.doSearchForReasons()

	}

	handleOnChangeCustomProductPrice = ( value ) => {

		if( value <= 0 ){
			value = 0;
		}

		this.setState({
			productPrice: value
		});

		this._dbnceUpdateCustomProductPrice()

	}

	handleOnFocusSelectAllText = (event) => {
		event.target.select();
	}


	/**
	 * @todo on select custom product
	 */
	handleOnSelectCustomProductTitle = ( customProduct ) => {

		this.props.onSelectCustomProductTitle( customProduct )
			.then( _product => {

				message.success(`Changed product title to ${_product.product.title}`);

				this.setState({
					typed: false,
					touched: false,
					title: _product.product.title
				});

			});

	}

	handleOnClickAddCustomProduct = () => {

		if( this.state.title.length <= 5 ){
			message.error("Title length must be greater than 5!");
		}

		_postAddCustomProduct( this.state.title )
			.then( res => {

				message.success(`Added custom product ${this.state.title}`);

				this.setState({ 
					results: [],
					typed: false,
					touched: false
				});

				this.handleOnSelectCustomProductTitle( res.data.product );
				
			})
			.catch( e => {
				message.error(e.response.data.e);
			})
	}

}

export default CustomProductSelector;


// WEBPACK FOOTER //
// ./src/components/quotation/add-quotation-modal/custom-product-selector.js